module.exports = __webpack_public_path__ + "assets/bee65503e19071c8ccd0bf54be472f07.mp3";